export const homeTimeline = async (token, max_id) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const fetch_url = max_id ? 'https://makegayfriends.com/api/v1/timelines/home?max_id='+max_id : 'https://makegayfriends.com/api/v1/timelines/home'
    const response = await fetch(fetch_url, { headers });
    const data = await response.json();
    return data
}